

/// <reference path="DBMappingEntity.ts" />

// Generated class DBMappingEntityPlace_ManagedObject

class DBMappingEntityPlace_ManagedObject extends DBMappingEntity
{
}
